export const Stats = {
    sum: (x: number[]) : number => x.reduce((a, b) => a + b, 0),
    mean: (x: number[]) : number => Stats.sum(x) / x.length,
    std: (x: number[]) : number => {
        const x_mean = Stats.mean(x);
        return Math.sqrt(Stats.sum(x.map((xi) => Math.pow(xi-x_mean, 2))) / x.length);
    }
};